export type RepeatType = "daily" | "weekly" | "monthly";

export const REPEAT_TYPE_LABEL: Record<RepeatType, string> = {
  daily: "매일",
  weekly: "매주",
  monthly: "매월",
};

export const DAY_OF_WEEK_LABEL: Record<string, string> = {
  "0": "일",
  "1": "월",
  "2": "화",
  "3": "수",
  "4": "목",
  "5": "금",
  "6": "토",
};

export interface BatchPreviewRequest {
  cpsCd: string;
  bldCd: string;
  plcCd: string;
  startDate: string; // YYYYMMDD
  endDate: string;   // YYYYMMDD
  repeatType: RepeatType;
  repeatDays: string; // comma-separated
  startTime: string;  // hhmmss
  endTime: string;    // hhmmss
}

/** 일괄 예약 기간과 시간대가 겹치는 기존 예약 한 건 */
export interface ConflictReservation {
  rsvtId: number;
  userName: string;
  cmtNm: string;
  useCnts: string;
  startTime: string; // hhmmss
  endTime: string; // hhmmss
}

export interface BatchPreviewResult {
  date: string; // YYYYMMDD
  available: boolean;
  /** 예약 가능한 날짜는 빈 배열 */
  conflicts: ConflictReservation[];
}

export interface RejectConflictsResponse {
  /** 실제로 반려된 예약 ID */
  rejected: number[];
  /** 존재하지 않거나(not_found) 이미 취소·반려된(already_closed) 예약 */
  skipped: { rsvtId: number; reason: string }[];
}

export interface BatchCreateRequest extends BatchPreviewRequest {
  groupName: string;
  useCnts: string;
  mbrId: string;
  skipDates: string[]; // YYYYMMDD format
}

export interface BatchGroup {
  batchId: number;
  cpsCd: string;
  groupName: string;
  repeatType: RepeatType;
  repeatDays: string | null;
  startDate: string;
  endDate: string;
  bldCd: string;
  plcCd: string;
  startTime: string | null;
  endTime: string | null;
  useCnts: string | null;
  mbrId: string | null;
  totalCount: number;
  createdCount: number;
  skippedCount: number;
  sttCd: string;
  crtId: string | null;
  crDt: string;
  updId: string | null;
  updDt: string;
}

export interface BatchDetailResponse extends BatchGroup {
  reservations: {
    rsvtId: number;
    rsvtDt: string;
    startTime: string;
    endTime: string;
    plcCd: string;
    useCnts: string;
    sttCd: string;
    mbrId: string;
  }[];
}
